<template>
    <ul class="n2-valid" v-bind:class="{'n2-validation-summary':hasError}">
        <template v-for="key in Object.keys(errors)">
            <li v-for="error in errors[key]" v-bind:key="error">{{ error }}</li>
        </template>
    </ul>
</template>
<script>
    export default {
        name: 'ValidationSummary',
        props: {
            errors: Object,
        },
        computed: {
            hasError: function () {
                return Object.keys(this.errors).length > 0
            }
        }
    }
</script>